import { setupApp } from '@/common/setup-app/setup-app.js'
import { useEmbedHeight } from '@/hooks/use-embed-height.ts'

import '../configuration/spark'
import '../configuration/axios'
import '../configuration/luxon'
import '../configuration/form'

import '../../css/embed-form.css'

setupApp()
useEmbedHeight()
